import React from "react";

import { Icon } from "../../../components/Icon/Icon";
import { useNavigate } from "react-router-dom";
import OtherProducts from "../OtherProducts/OtherProducts";
import { useInView } from "react-intersection-observer";

import threeProducts from "../../../assets/images/Infinite60x50/three-products.png";
import threeProductsTwo from "../../../assets/images/Infinite60x50/three-products-two.png";
import office from "../../../assets/images/office.png";
import productWavesTop from "../../../assets/images/Infinite60x50/product-waves-top.png";
import qualcomm from "../../../assets/images/qualcomm-5g-sdx62.png";
import FlickitySlider from "../../../components/FlickitySlider/FlickitySlider";
import allProducts from "../../../assets/images/all-products.jpeg";
import productWallpaper from "../../../assets/images/Infinite60x50/60x50-wallpaper.png";
import product60x50Bottom from "../../../assets/images/Infinite60x50/60x50-bottom-two.png";
import wifiSixGroup from "../../../assets/images/wifiSixGroupTwo.png";
import productCartOne from "../../../assets/images/Infinite60x50/60x50.png";
import productCartTwo from "../../../assets/images/Infinite60x50/60x50-bottom-three.png";
import productCartThree from "../../../assets/images/Infinite60x50/60x50-front.png";
import cs from "classnames";

import "./Infinite60.scss";

const Infinite60 = () => {
  const navigate = useNavigate();
  const [productTitleRef, productTitleVisibility] = useInView();
  const [productImageRef, productImageVisibility] = useInView();
  const [sixCartTitleRef, sixCartTitleVisibility] = useInView();
  const [cartOneRef, cartOneVisibility] = useInView();
  const [cartTwoRef, cartTwoVisibility] = useInView();
  const [cartThreeRef, cartThreeVisibility] = useInView();
  const [cartFourRef, cartFourVisibility] = useInView();
  const [cartFiveRef, cartFiveVisibility] = useInView();
  const [cartSixRef, cartSixVisibility] = useInView();
  const [productOutlineSubTitleRef, productOutlineSubTitleVisibility] =
    useInView();
  const [productOutlineImageRef, productOutlineImageVisibility] = useInView();
  const [topTextOneRef, topTextOneVisibility] = useInView();
  const [topTextTwoRef, topTextTwoVisibility] = useInView();
  const [bottomTextOneRef, bottomTextOneVisibility] = useInView();
  const [bottomTextTwoRef, bottomTextTwoVisibility] = useInView();
  const [wifiSixImageRef, wifiSixImageVisibility] = useInView();
  const [wifiSixTitleRef, wifiSixTitleVisibility] = useInView();
  const [wifiSixCartImageRef, wifiSixCartImageVisibility] = useInView();
  const [officeHeadRef, officeHeadVisibility] = useInView();
  const [officeImageRef, officeImageVisibility] = useInView();
  const [otherProductsTitleRef, otherProductsTitleVisibility] = useInView();

  return (
    <div className="InfiniteProduct60">
      <div className="ProductHeader60">
        <div className="ProductHeader60__container">
          <div className="ProductHeader60__left">
            <div
              className="ProductHeader60__products"
              onClick={() => {
                navigate("/products");
              }}
            >
              Products
            </div>
            <Icon className="ProductHeader60__icon" icon="chevron-right" />
            <div className="ProductHeader60__product">Infinite 60</div>
          </div>
          <div className="ProductHeader60__right">
            <div className="ProductHeader60__design">Design</div>
            <div className="ProductHeader60__features">Features</div>
            <div className="ProductHeader60__specifications">
              Specifications
            </div>
          </div>
        </div>
      </div>
      <div className="ProductImage60">
        <div className="ProductImage60__container">
          <div
            ref={productTitleRef}
            className={cs(
              "ProductImage60__title",
              productTitleVisibility && "ProductImage60__title-animation",
            )}
          >
            Infinite <span>60</span>{" "}
          </div>
          <img
            ref={productImageRef}
            className={cs(
              "ProductImage60__image",
              productImageVisibility && "ProductImage60__image-animation",
            )}
            src={threeProducts}
          />
        </div>
      </div>

      <div className="SixCart60">
        <div className="SixCart60__container">
          <div
            ref={sixCartTitleRef}
            className={cs(
              "SixCart60__title",
              sixCartTitleVisibility && "SixCart60__title-animation",
            )}
          >
            Connecting You to <span>Tomorrow </span>
          </div>
          <div className="SixCart60__carts">
            <div
              ref={cartOneRef}
              className={cs(
                "SixCart60__cart",
                "SixCart60__cartOne",
                cartOneVisibility && "SixCart60__cartOne-animation",
              )}
            >
              <div className="SixCart60__cartOne-textOne">
                Bandwidth Mastery
              </div>
              <img
                loading="lazy"
                src={threeProductsTwo}
                className="SixCart60__cartOne-image"
              />
              <div className="SixCart60__cartOne-textTwo">
                Perfect for high-demand online gaming and 4K video streaming.
              </div>
            </div>
            <div
              ref={cartTwoRef}
              className={cs(
                "SixCart60__cart",
                "SixCart60__cartTwo",
                cartTwoVisibility && "SixCart60__cartTwo-animation",
              )}
            >
              <div className="SixCart60__cartTwo-textOne">
                Qualcomm Performance
              </div>
              <img loading="lazy" className="SixCart60__cartTwo-image" />
              <div className="SixCart60__cartTwo-textTwo">
                Leverage cutting-edge Qualcomm technology for smooth network
                transitions.
              </div>
            </div>
            <div
              ref={cartThreeRef}
              className={cs(
                "SixCart60__cart",
                "SixCart60__cartThree",
                cartThreeVisibility && "SixCart60__cartThree-animation",
              )}
            >
              <div className="SixCart60__cartThree-textOne">Seamless Setup</div>
              <div className="SixCart60__cartThree-textTwo">
                Instantly integrate and activate with Infinite 60's
                plug-and-play functionality.
              </div>
            </div>
            <div
              ref={cartFourRef}
              className={cs(
                "SixCart60__cart",
                "SixCart60__cartFour",
                cartFourVisibility && "SixCart60__cartFour-animation",
              )}
            >
              <div className="SixCart60__cartFour-textOne">
                High-Speed Downloads
              </div>
              <img
                loading="lazy"
                src={office}
                className="SixCart60__cartFour-image"
              />
              <div className="SixCart60__cartFour-textTwo">
                Achieves up to 3.4 Gbps download rates, ensuring a premium
                online experience.
              </div>
            </div>
            <div
              ref={cartFiveRef}
              className={cs(
                "SixCart60__cart",
                "SixCart60__cartFive",
                cartFiveVisibility && "SixCart60__cartFive-animation",
              )}
            >
              <div className="SixCart60__cartFive-textOne">Wi-Fi 6 Enabled</div>
              <img
                loading="lazy"
                src={productWavesTop}
                className="SixCart60__cartFive-image"
              />
              <div className="SixCart60__cartFive-textTwo">
                Offers up to 5.4Gbps speeds, supporting 164 users with ease.
              </div>
            </div>
            <div
              ref={cartSixRef}
              className={cs(
                "SixCart60__cart",
                "SixCart60__cartSix",
                cartSixVisibility && "SixCart60__cartSix-animation",
              )}
            >
              <div className="SixCart60__cartSix-textOne">5G Connectivity</div>
              <img loading="lazy" className="SixCart60__cartSix-image" />
              <div className="SixCart60__cartSix-textTwo">
                The Infinite 60 boasts the Snapdragon X62 modem for unparalleled
                5G speeds.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ProductOutline60">
        <div className="ProductOutline60__container">
          <div
            ref={productOutlineSubTitleRef}
            className={cs(
              "ProductOutline60__subtitle",
              productOutlineSubTitleVisibility &&
                "ProductOutline60__subtitle-animation",
            )}
          >
            Empowered Connectivity for Everyday Use <br /> Speed and Reliability
          </div>
          <div className="ProductOutline60__body">
            <img
              ref={productOutlineImageRef}
              loading="lazy"
              className={cs(
                "ProductOutline60__image",
                productOutlineImageVisibility &&
                  "ProductOutline60__image-animation",
              )}
              src={productCartOne}
            />
          </div>
        </div>
      </div>

      <div className="TwoSections60">
        <div className="TwoSections60__top">
          <div className="TwoSections60__top-left">
            <img className="TwoSections60__top-left-image" src={qualcomm} />
          </div>
          <div className="TwoSections60__top-right">
            <div
              ref={topTextOneRef}
              className={cs(
                "TwoSections60__top-right-textOne",
                topTextOneVisibility &&
                  "TwoSections60__top-right-textOne-animation",
              )}
            >
              Lightning Speed, Rock-Solid Reliability, The Qualcomm-Powered
              Experience
            </div>
            <div
              ref={topTextTwoRef}
              className={cs(
                "TwoSections60__top-right-textTwo",
                topTextTwoVisibility &&
                  "TwoSections60__top-right-textTwo-animation",
              )}
            >
              Harnessing the power of the Qualcomm IPQ5018 chipset and the
              cutting-edge SDX62 5G modem, this device ensures lightning-fast
              connections and steadfast reliability, redefining your digital
              experience.
            </div>
          </div>
        </div>
        <div className="TwoSections60__bottom">
          <div className="TwoSections60__bottom-left">
            <div
              ref={bottomTextOneRef}
              className={cs(
                "TwoSections60__bottom-left-textOne",
                bottomTextOneVisibility &&
                  "TwoSections60__bottom-left-textOne-animation",
              )}
            >
              Seamless Elegance <br />
              The Power of Design in Technology
            </div>
            <div
              ref={bottomTextTwoRef}
              className={cs(
                "TwoSections60__bottom-left-textTwo",
                bottomTextTwoVisibility &&
                  "TwoSections60__bottom-left-textTwo-animation",
              )}
            >
              Design melds form with function, making technology both appealing
              and intuitive, transforming everyday interactions into seamless,
              enjoyable experiences.
            </div>
          </div>
          <div className="TwoSections60__bottom-right">
            <img
              className="TwoSections60__bottom-right-image"
              src={product60x50Bottom}
            />
          </div>
        </div>
      </div>

      <div className="WifiSix60">
        <img
          ref={wifiSixImageRef}
          src={wifiSixGroup}
          className={cs(
            "WifiSix60__image",
            wifiSixImageVisibility && "WifiSix60__image-animation",
          )}
        />
        <div
          ref={wifiSixTitleRef}
          className={cs(
            "WifiSix60__title",
            wifiSixTitleVisibility && "WifiSix60__title-animation",
          )}
        >
          Workspace-Ready Connectivity <br /> Unveiling the Infinite 60
        </div>
        <div className="WifiSix60__carts">
          <div className="WifiSix60__cart">
            <img src={productCartOne} className="WifiSix60__cart-image" />
            <div className="WifiSix60__cart-text">
              <div className="WifiSix60__cart-textOne">
                Workspace-Ready Design
              </div>
              <div className="WifiSix60__cart-textTwo">
                Crafted to seamlessly integrate into any workspace, the Infinite
                60's modern design elevates aesthetics while maximizing
                functionality.
              </div>
            </div>
          </div>
          <div className={cs("WifiSix60__cart", "WifiSix60__cart-middle")}>
            <img
              ref={wifiSixCartImageRef}
              src={productCartTwo}
              className={cs(
                "WifiSix60__cart-image",
                "WifiSix60__cart-image-middle",
                wifiSixCartImageVisibility &&
                  "WifiSix60__cart-image-middle-animation",
              )}
            />
            <div className="WifiSix60__cart-text">
              <div
                className={cs(
                  "WifiSix60__cart-textOne",
                  "WifiSix60__cart-textOne-middle",
                )}
              >
                Tailored Connectivity Solutions
              </div>
              <div
                className={cs(
                  "WifiSix60__cart-textTwo",
                  "WifiSix60__cart-textTwo-middle",
                )}
              >
                Customizable features ensure the Infinite 60 meets the diverse
                connectivity demands of modern workspaces, catering to both
                gaming enthusiasts and professionals.
              </div>
            </div>
          </div>
          <div className="WifiSix60__cart">
            <img src={productCartThree} className="WifiSix60__cart-image" />
            <div className="WifiSix60__cart-text">
              <div className="WifiSix60__cart-textOne">
                Efficiency and Performance
              </div>
              <div className="WifiSix60__cart-textTwo">
                Engineered for optimal performance in workspace environments,
                the Infinite 60 delivers reliable connectivity and swift
                response times, enhancing productivity across various tasks.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="Office60">
        <div className="Office60__container">
          <div
            ref={officeHeadRef}
            className={cs(
              "Office60__head",
              officeHeadVisibility && "Office60__head-animation",
            )}
          >
            <div className="Office60__head-left">
              Maximize Your Network Potential
            </div>
            <div className="Office60__head-right">
              <div className="Office60__head-right-left">+128</div>
              <div className="Office60__head-right-right">
                The Infinite 60 supports up to 128 users, offering stable
                connectivity and setting the standard for high-capacity
                networks.
              </div>
            </div>
          </div>
          <img
            ref={officeImageRef}
            loading="lazy"
            className={cs(
              "Office60__image",
              officeImageVisibility && "Office60__image-animation",
            )}
            src={office}
          />
        </div>
      </div>

      <div className="Specifications60">
        <div className="Specifications60__container">
          <div className="Specifications60__title">Specifications</div>
          <div className="Specifications60__subtitle">Hardware</div>
          <div className="Specifications60__section">
            <div className="Specifications60__section-left">
              <div className="Specifications60__section-title">5G Chipset</div>
            </div>
            <div className="Specifications60__section-right">
              <div
                className={cs(
                  "Specifications60__section-description",
                  "Specifications60__section-description-borderNone",
                )}
              >
                5G Qualcomm SDX62
              </div>
            </div>
          </div>
          <div className="Specifications60__section">
            <div className="Specifications60__section-left">
              <div className="Specifications60__section-title">
                Wi-Fi Chipset
              </div>
            </div>
            <div className="Specifications60__section-right">
              <div className="Specifications60__section-description">
                Wi-Fi 6 Qualcomm IPQ5018 +QCN6024
              </div>{" "}
              <div className="Specifications60__section-description">
                2T2R 2.4GHz 802.11b/g/n/ac/ax, 573.5Mbps
              </div>
              <div className="Specifications60__section-description">
                4T4R 5.8GHz 802.11a/n/ac/ax, 4804Mbps
              </div>
              <div
                className={cs(
                  "Specifications60__section-description",
                  "Specifications60__section-description-borderNone",
                )}
              >
                3 dBi internal 2.4G&5G dual band antenna
              </div>
            </div>
          </div>

          <div className="Specifications60__section">
            <div className="Specifications60__section-left">
              <div className="Specifications60__section-title">
                Device Interfaces
              </div>
            </div>
            <div className="Specifications60__section-right">
              <div className="Specifications60__section-description">
                1 x 1Gbps LAN Ethernet
              </div>
              <div className="Specifications60__section-description">
                1 x 2.5Gbps WAN Ethernet
              </div>
              <div className="Specifications60__section-description">
                1 x Power jack
              </div>{" "}
              <div className="Specifications60__section-description">
                1 x Phone jack
              </div>
              <div
                className={cs(
                  "Specifications60__section-description",
                  "Specifications60__section-description-borderNone",
                )}
              >
                Maximum Concurrent Users – 164 Devices
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ImageSlider60">
        <FlickitySlider
          options={{
            lazyLoad: 10,
            wrapAround: true,
            contain: true,
            draggable: true,
            autoPlay: true,
            freeScroll: true,
            imagesLoaded: true,
            prevNextButtons: false,
          }}
        >
          <div className="ImageSlider60__image-container">
            <img
              loading="lazy"
              className="ImageSlider60__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider60__image-container">
            <img
              loading="lazy"
              className="ImageSlider60__image"
              data-flickity-lazyload={productWallpaper}
            />
          </div>
          <div className="ImageSlider60__image-container">
            <img
              loading="lazy"
              className="ImageSlider60__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider60__image-container">
            <img
              loading="lazy"
              className="ImageSlider60__image"
              data-flickity-lazyload={productWallpaper}
            />
          </div>
        </FlickitySlider>
      </div>

      <div className="OtherProducts60">
        <div className="OtherProducts60__container">
          <div
            ref={otherProductsTitleRef}
            className={cs(
              "OtherProducts60__title",
              otherProductsTitleVisibility &&
                "OtherProducts60__title-animation",
            )}
          >
            Other Products
          </div>
          <OtherProducts />
        </div>
      </div>
    </div>
  );
};

export default Infinite60;
